import styled from '@emotion/styled'
import { FunctionComponent, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { TabProp } from '~/components/Tabs'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { WithClassName } from '~/types/utils'
import { PureAdmRefreshPage } from './PureAdmRefreshPage'

type TabLabel = 'Rules' | 'Global settings'

const refreshTabs: TabProp[] = [
  { label: 'Rules', trackingLabel: 'adm-refresh-rules-tab-apply' },
  { label: 'Global settings', trackingLabel: 'adm-refresh-rules-global-settings-tab-apply' },
]

const tabLabelToPath: { [key in TabLabel]: string } = {
  Rules: 'rules',
  'Global settings': 'global-settings',
}

type AdmRefreshPageProps = WithClassName

const BaseAdmRefreshPage: FunctionComponent<AdmRefreshPageProps> = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const tabLabelFromLocation = (Object.keys(tabLabelToPath) as Array<keyof typeof tabLabelToPath>).find(
    (key) => tabLabelToPath[key] === (location.pathname.split('/').find((dir) => Object.values(tabLabelToPath).includes(dir)) ?? 'rules')
  )

  const [activeTab, setActiveTab] = useState<TabLabel>(tabLabelFromLocation ?? 'Rules')
  const [previousTabLabelFromLocation, setPreviousTabLabelFromLocation] = useState(tabLabelFromLocation)

  // the url drives the active tab: realign on navigation, during render rather than in an effect
  if (previousTabLabelFromLocation !== tabLabelFromLocation) {
    setPreviousTabLabelFromLocation(tabLabelFromLocation)
    setActiveTab(tabLabelFromLocation ?? 'Rules')
  }

  const breadcrumbs = useBreadcrumbs()

  return (
    <PureAdmRefreshPage
      breadcrumbs={breadcrumbs}
      onTabClick={(tab) => {
        setActiveTab(tab.label as TabLabel)
        navigate(tabLabelToPath[tab.label as TabLabel])
      }}
      tabs={refreshTabs.map((t) => ({ ...t, active: t.label === activeTab }))}
    >
      <Outlet />
    </PureAdmRefreshPage>
  )
}

export const AdmRefreshPage = styled(BaseAdmRefreshPage)``
